import { MAX_EVENT_ATTRIBUTE_VALUES_COUNT } from '../../../../../constants/common.constants';

export const EXTERNAL_ID_UNIQUE_TEXT = {
    id: 'oe.eventAttributes.externalIdMustBeUnique',
    defaultMessage: 'External ID must be unique within the attribute',
    description: 'external ID error message'
};

export const LABEL_UNIQUE_TEXT = {
    id: 'oe.eventAttributes.labelMustBeUnique',
    defaultMessage: 'Label must be unique within the attribute',
    description: 'label error message'
};
export const ATTRIBUTE_MAX_VALUE_VALIDATION_TEXT = {
    id: 'oe.eventAttributes.maxValuesReached',
    defaultMessage: `You can add up to max ${MAX_EVENT_ATTRIBUTE_VALUES_COUNT} values only.`,
    description: 'Max length error message'
};

export const ATTRIBUTE_MIN_VALUE_VALIDATION_TEXT = {
    id: 'oe.eventAttributes.minValuesRequired',
    defaultMessage: 'Please add at least one value to save the attribute data',
    description: 'Values error message'
};